<template>
  <div class="center">
    <div class="lds-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/services/http-common";

export default {
  name: "LoadingGame",
  mounted() {
    let provider = this.$route.params.provider;
    let gamecode = this.$route.params.game;

    if (provider == "sport") {
      HTTP.get(`game/ufa/enter`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("lb_token"),
        },
      })
        .then((resp) => {
          window.location.href = resp.data.game.gameUrl;
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 401) {
              this.$store.dispatch("logoutAuth");
            } else {
              this.$toast.error(
                err.response.data.msg != undefined
                  ? err.response.data.msg
                  : "ไม่สามารถเข้าเล่นเกมได้ กรุณาลองใหม่"
              );
            }
          }
        });
    } else {
      HTTP.post(
        `game/betflix/enter`,
        {
          provider: this.CheckProvider(provider),
          gamecode: gamecode,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("lb_token"),
          },
        }
      )
        .then((resp) => {
          window.location.href = resp.data.game.launch_url;
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 401) {
              this.$store.dispatch("logoutAuth");
            } else {
              this.$toast.error(
                err.response.data.msg != undefined
                  ? err.response.data.msg
                  : "ไม่สามารถเข้าเล่นเกมได้ กรุณาลองใหม่"
              );
              // setTimeout(() => {
              //   window.location.href = "/";
              // }, 2000);
            }
          }
        });
    }
  },
  methods: {
    CheckProvider(provider) {
      if (
        provider === "BPG" ||
        provider === "BNG" ||
        provider === "HAB" ||
        provider === "KGL" ||
        provider === "RLX" ||
        provider === "YGG" ||
        provider === "RED" ||
        provider === "QS" ||
        provider === "IDS" ||
        provider === "TK" ||
        provider === "MAV" ||
        provider === "DS" ||
        provider === "NLC" ||
        provider === "GA" ||
        provider === "PNG" ||
        provider === "PUG" ||
        provider === "FNG" ||
        provider === "NGE" ||
        provider === "1X2" ||
        provider === "HAK" ||
        provider === "WAZ" ||
        provider === "ELK" ||
        provider === "PRS"
      ) {
        return "qtech";
      } else {
        return provider;
      }
    },
  },
};
</script>

<style>
.lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
  width: 120px;
  height: 120px;
}
.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: rgb(10, 2, 2);
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.center {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
